import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_DM_PROFILE_RESPONSIVENESS_SCORE_DATA = createFcmDetails(
	'dm_profile_responsiveness_score_data',
	{
		owner: 'Capybara Squad',
		context: 'Decision maker proile page responsiveness score',
		import: false,
		description: `As a first step to implementing responsiveness score, we're leveraging an FC to hold 
    data about some selected DMs, for use on the frontend. The data here is obtained from redash.`,
		template: [
			{
				petition_target_id: '1',
				name: 'Decision Maker',
				state: 'CA',
				district: '24',
				total_relevant_petitions: 2,
				responded_to_petitions: 1,
				responsiveness_score: 50,
				dm_profile_link: 'https://www.change.org/decision-makers/1',
				decisionMakers: [
					{
						petition_target_id: '1',
						name: 'Decision Maker',
						state: 'CA',
						district: '24',
						total_relevant_petitions: 2,
						responded_to_petitions: 1,
						responsiveness_score: 50,
						dm_profile_link: 'https://www.change.org/decision-makers/1',
					},
				],
			},
		],
	},
);
